import { useMutation } from "urql";

import { SendDeskCollectionDocument } from "../../../../graphql/generated.ts";

export function useSendDeskCollection() {
  return useMutation(SendDeskCollectionDocument);
}
